<template>
    <div class="conflict-form">
        <div class="row">
            <div class="col-default-6 col-v-tablet-12">
                <z-link href="https://files.raspadskaya.com/files/ru/sustainability/anticorruption/soglasie.docx" internal icon-position="left">Ссылка на полный текст соглашения</z-link>
                <z-checkbox
                    class="u-top-margin--m"
                    name="agreement"
                    ref="agreement"
                    required
                    :checked="params.agreement"
                    @change="onBlockDataChange"
                >
                    Согласен<span class="black-90-text">*</span>
                </z-checkbox>
            </div>
            <div class="col-default-6 col-v-tablet-12">
                <z-select
                    :data="[
                        {
                            'id': 1,
                            'selected': false,
                            'text': 'ЦОФ «Абашевская»',
                        },
                        {
                            'id': 2,
                            'selected': false,
                            'text': 'ЦОФ «Кузнецкая»',
                        },
                        {
                            'id': 3,
                            'selected': false,
                            'text': 'Шахта «Абашевская»',
                        },
                        {
                            'id': 4,
                            'selected': false,
                            'text': 'Шахта «Алардинская»',
                        },
                        {
                            'id': 5,
                            'selected': false,
                            'text': 'Шахта «Есаульская»',
                        },
                        {
                            'id': 6,
                            'selected': false,
                            'text': 'Шахта «Осинниковская»',
                        },
                        {
                            'id': 7,
                            'selected': false,
                            'text': 'Шахта «Усковская»',
                        },
                        {
                            'id': 8,
                            'selected': false,
                            'text': 'АТП «Южкузбассуголь»',
                        },
                        {
                            'id': 9,
                            'selected': false,
                            'text': 'Кузнецкпогрузтранс',
                        },
                        {
                            'id': 10,
                            'selected': false,
                            'text': 'Южно-Кузбасское геологоразведочное управление',
                        },
                        {
                            'id': 11,
                            'selected': false,
                            'text': 'Промуглепроект',
                        },
                        {
                            'id': 12,
                            'selected': false,
                            'text': 'Осинниковский ремонтно-механический завод',
                        },
                        {
                            'id': 13,
                            'selected': false,
                            'text': 'Специализированно шахтномонтажно-наладочное управление',
                        },
                        {
                            'id': 14,
                            'selected': false,
                            'text': 'УМГШО',
                        },
                        {
                            'id': 15,
                            'selected': false,
                            'text': 'ПАО «Распадская»',
                        },
                        {
                            'id': 16,
                            'selected': false,
                            'text': 'Разрез «Распадский»',
                        },
                        {
                            'id': 17,
                            'selected': false,
                            'text': 'Монтажник Распадской',
                        },
                        {
                            'id': 18,
                            'selected': false,
                            'text': 'Ольжерасское шахтопроходческое управление',
                        },
                        {
                            'id': 19,
                            'selected': false,
                            'text': 'Распадская-Коксовая',
                        },
                        {
                            'id': 20,
                            'selected': false,
                            'text': 'Обогатительная фабрика «Распадская»',
                        },
                        {
                            'id': 21,
                            'selected': false,
                            'text': 'Томусинское погрузочно-транспортное управление',
                        },
                        {
                            'id': 22,
                            'selected': false,
                            'text': 'ООО «РУК»',
                        }
                    ]"
                    placeholder="Предприятие*"
                    name="DIVIZ"
                    ref="DIVIZ"
                    @change="onSelDataChange"
                    required
                ></z-select>
            </div>
        </div>
        <div class="row">
            <div class="col-default-6 col-v-tablet-12">
                <z-input
                    placeholder="Фамилия*"
                    name="LAST_NAME"
                    ref="LAST_NAME"
                    required
                    v-model="params['LAST_NAME']"
                />
            </div>
            <div class="col-default-6 col-v-tablet-12">
                <z-input
                    placeholder="Имя*"
                    name="FIRST_NAME"
                    ref="FIRST_NAME"
                    required
                    v-model="params['FIRST_NAME']"
                />
            </div>
        </div>
        <div class="row">
            <div class="col-default-6 col-v-tablet-12">
                <z-input
                    placeholder="Отчество*"
                    name="MIDDLE_NAME"
                    ref="MIDDLE_NAME"
                    required
                    v-model="params['MIDDLE_NAME']"
                />
            </div>
            <div class="col-default-6 col-v-tablet-12">

            </div>
        </div>
        <div class="sg-section">
            <z-caption tag="p" class="u-top-margin--m u-bottom-margin--xs" size="m">
                1. Отношения с компаниями - контрагентами
            </z-caption>
        </div>
        <div class="row">
            <div class="col-default-12">
                <z-caption tag="p" class="u-top-margin--m u-bottom-margin--xs" size="s">
                    1.1	Имеете ли Вы или член Вашей семьи собственность или финансовые интересы в любой компании-контрагенте ООО «РУК», Управляемых Обществ или иных предприятий группы ПАО «Распадская»?<span class="black-90-text">*</span>
                </z-caption>
                <div class="row">
                    <div class="col-default-6 col-v-tablet-12">
                        <z-checkbox
                            name="question_y1[1]"
                            ref="question_y1[1]"
                            required
                            :checked="params.question_y1[1]"
                            @change="onBlockDataChangequestion"
                        >
                            Да
                        </z-checkbox>
                        <z-checkbox
                            name="question_n1[1]"
                            ref="question_n1[1]"
                            required
                            :checked="params.question_n1[1]"
                            @change="onBlockDataChangequestion"
                        >
                            Нет
                        </z-checkbox>
                    </div>
                    <div class="col-default-6 col-v-tablet-12">
                        <z-textarea
                            name="explanation_1[1]"
                            ref="explanation_1[1]"
                            placeholder="Пояснение к 1.1"
                            v-model="params.explanation_1[1]"
                            resize
                        />
                    </div>
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-default-12">
                <z-caption tag="p" class="u-bottom-margin--xs" size="s">
                    1.2	Являетесь ли Вы или член Вашей семьи руководителем или учредителем в любой компании-контрагенте ООО «РУК», Управляемых Обществ или иных предприятий группы ПАО «Распадская»?<span class="black-90-text">*</span>
                </z-caption>
                <div class="row">
                    <div class="col-default-6 col-v-tablet-12">
                        <z-checkbox
                            name="question_y1[2]"
                            ref="question_y1[2]"
                            required
                            :checked="params.question_y1[2]"
                            @change="onBlockDataChangequestion"
                        >
                            Да
                        </z-checkbox>
                        <z-checkbox
                            name="question_n1[2]"
                            ref="question_n1[2]"
                            required
                            :checked="params.question_n1[2]"
                            @change="onBlockDataChangequestion"
                        >
                            Нет
                        </z-checkbox>
                    </div>
                    <div class="col-default-6 col-v-tablet-12">
                        <z-textarea
                            name="explanation_1[2]"
                            ref="explanation_1[2]"
                            placeholder="Пояснение к 1.2"
                            v-model="params.explanation_1[2]"
                            resize
                        />
                    </div>
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-default-12">
                <z-caption tag="p" class="u-bottom-margin--xs" size="s">
                    1.3	Есть ли у Вас или у члена Вашей семьи отношения найма (контракт) или консультационные отношения с какой-либо компанией-контрагентом ООО «РУК», Управляемых Обществ или иных предприятий группы ПАО «Распадская»?<span class="black-90-text">*</span>
                </z-caption>
                <div class="row">
                    <div class="col-default-6 col-v-tablet-12">
                        <z-checkbox
                            name="question_y1[3]"
                            ref="question_y1[3]"
                            required
                            :checked="params.question_y1[3]"
                            @change="onBlockDataChangequestion"
                        >
                            Да
                        </z-checkbox>
                        <z-checkbox
                            name="question_n1[3]"
                            ref="question_n1[3]"
                            required
                            :checked="params.question_n1[3]"
                            @change="onBlockDataChangequestion"
                        >
                            Нет
                        </z-checkbox>
                    </div>
                    <div class="col-default-6 col-v-tablet-12">
                        <z-textarea
                            name="explanation_1[3]"
                            ref="explanation_1[3]"
                            placeholder="Пояснение к 1.3"
                            v-model="params.explanation_1[3]"
                            resize
                        />
                    </div>
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-default-12">
                <z-caption tag="p" class="u-bottom-margin--xs" size="s">
                    1.4	Получали ли Вы от контрагентов Компании или их представителей денежное вознаграждение за оказанные услуги, в том числе в виде оплаты Вашего кредита или долга?<span class="black-90-text">*</span>
                </z-caption>
                <div class="row">
                    <div class="col-default-6 col-v-tablet-12">
                        <z-checkbox
                            name="question_y1[4]"
                            ref="question_y1[4]"
                            required
                            :checked="params.question_y1[4]"
                            @change="onBlockDataChangequestion"
                        >
                            Да
                        </z-checkbox>
                        <z-checkbox
                            name="question_n1[4]"
                            ref="question_n1[4]"
                            required
                            :checked="params.question_n1[4]"
                            @change="onBlockDataChangequestion"
                        >
                            Нет
                        </z-checkbox>
                    </div>
                    <div class="col-default-6 col-v-tablet-12">
                        <z-textarea
                            name="explanation_1[4]"
                            ref="explanation_1[4]"
                            placeholder="Пояснение к 1.4"
                            v-model="params.explanation_1[4]"
                            resize
                        />
                    </div>
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-default-12">
                <z-caption tag="p" class="u-bottom-margin--xs" size="s">
                    1.5	Получали ли Вы или член Вашей семьи от контрагента ООО «РУК», Управляемых Обществ или иных предприятий группы ПАО «Распадская» какие-либо подарки эквивалентной стоимостью более 100 долларов США, которые не были ранее заявлены и одобрены в соответствии с политикой Компании?<span class="black-90-text">*</span>
                </z-caption>
                <div class="row">
                    <div class="col-default-6 col-v-tablet-12">
                        <z-checkbox
                            name="question_y1[5]"
                            ref="question_y1[5]"
                            required
                            :checked="params.question_y1[5]"
                            @change="onBlockDataChangequestion"
                        >
                            Да
                        </z-checkbox>
                        <z-checkbox
                            name="question_n1[5]"
                            ref="question_n1[5]"
                            required
                            :checked="params.question_n1[5]"
                            @change="onBlockDataChangequestion"
                        >
                            Нет
                        </z-checkbox>
                    </div>
                    <div class="col-default-6 col-v-tablet-12">
                        <z-textarea
                            name="explanation_1[5]"
                            ref="explanation_1[5]"
                            placeholder="Пояснение к 1.5"
                            v-model="params.explanation_1[5]"
                            resize
                        />
                    </div>
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-default-12">
                <z-caption tag="p" class="u-bottom-margin--xs" size="s">
                    1.6	Принимали ли Вы или член Вашей семьи какие-либо приглашения в поездки или на мероприятия от компаний-контрагентов ООО «РУК», Управляемых Обществ или иных предприятий группы ПАО «Распадская» совокупной эквивалентной стоимостью более 500 долларов США, которые не были ранее согласованы комплаенс менеджером?<span class="black-90-text">*</span>
                </z-caption>
                <div class="row">
                    <div class="col-default-6 col-v-tablet-12">
                        <z-checkbox
                            name="question_y1[6]"
                            ref="question_y1[6]"
                            required
                            :checked="params.question_y1[6]"
                            @change="onBlockDataChangequestion"
                        >
                            Да
                        </z-checkbox>
                        <z-checkbox
                            name="question_n1[6]"
                            ref="question_n1[6]"
                            required
                            :checked="params.question_n1[6]"
                            @change="onBlockDataChangequestion"
                        >
                            Нет
                        </z-checkbox>
                    </div>
                    <div class="col-default-6 col-v-tablet-12">
                        <z-textarea
                            name="explanation_1[6]"
                            ref="explanation_1[6]"
                            placeholder="Пояснение к 1.6"
                            v-model="params.explanation_1[6]"
                            resize
                        />
                    </div>
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-default-12">
                <z-caption tag="p" class="u-bottom-margin--xs" size="s">
                    1.7	Дарили ли Вы или член Вашей семьи подарки или приглашения на мероприятия какому-либо представителю контрагентов Компании. Вопрос касается подарков совокупной эквивалентной стоимостью более 100 долларов США, которые не были ранее согласованы комплаенс менеджером?<span class="black-90-text">*</span>
                </z-caption>
                <div class="row">
                    <div class="col-default-6 col-v-tablet-12">
                        <z-checkbox
                            name="question_y1[7]"
                            ref="question_y1[7]"
                            required
                            :checked="params.question_y1[7]"
                            @change="onBlockDataChangequestion"
                        >
                            Да
                        </z-checkbox>
                        <z-checkbox
                            name="question_n1[7]"
                            ref="question_n1[7]"
                            required
                            :checked="params.question_n1[7]"
                            @change="onBlockDataChangequestion"
                        >
                            Нет
                        </z-checkbox>
                    </div>
                    <div class="col-default-6 col-v-tablet-12">
                        <z-textarea
                            name="explanation_1[7]"
                            ref="explanation_1[7]"
                            placeholder="Пояснение к 1.7"
                            v-model="params.explanation_1[7]"
                            resize
                        />
                    </div>
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-default-12">
                <z-caption tag="p" class="u-bottom-margin--xs" size="s">
                    1.8	Давали ли в долг Вы или член Вашей семьи любую сумму денег владельцам или сотрудникам контрагента Компании?<span class="black-90-text">*</span>
                </z-caption>
                <div class="row">
                    <div class="col-default-6 col-v-tablet-12">
                        <z-checkbox
                            name="question_y1[8]"
                            ref="question_y1[8]"
                            required
                            :checked="params.question_y1[8]"
                            @change="onBlockDataChangequestion"
                        >
                            Да
                        </z-checkbox>
                        <z-checkbox
                            name="question_n1[8]"
                            ref="question_n1[8]"
                            required
                            :checked="params.question_n1[8]"
                            @change="onBlockDataChangequestion"
                        >
                            Нет
                        </z-checkbox>
                    </div>
                    <div class="col-default-6 col-v-tablet-12">
                        <z-textarea
                            name="explanation_1[8]"
                            ref="explanation_1[8]"
                            placeholder="Пояснение к 1.8"
                            v-model="params.explanation_1[8]"
                            resize
                        />
                    </div>
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-default-12">
                <z-caption tag="p" class="u-bottom-margin--xs" size="s">
                    1.9	Получали ли в долг Вы или член Вашей семьи любую сумму денег от владельцев или сотрудников контрагентов Компании?<span class="black-90-text">*</span>
                </z-caption>
                <div class="row">
                    <div class="col-default-6 col-v-tablet-12">
                        <z-checkbox
                            name="question_y1[9]"
                            ref="question_y1[9]"
                            required
                            :checked="params.question_y1[9]"
                            @change="onBlockDataChangequestion"
                        >
                            Да
                        </z-checkbox>
                        <z-checkbox
                            name="question_n1[9]"
                            ref="question_n1[9]"
                            required
                            :checked="params.question_n1[9]"
                            @change="onBlockDataChangequestion"
                        >
                            Нет
                        </z-checkbox>
                    </div>
                    <div class="col-default-6 col-v-tablet-12">
                        <z-textarea
                            name="explanation_1[9]"
                            ref="explanation_1[9]"
                            placeholder="Пояснение к 1.9"
                            v-model="params.explanation_1[9]"
                            resize
                        />
                    </div>
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-default-12">
                <z-caption tag="p" class="u-bottom-margin--xs" size="s">
                    1.10 Передавали ли Вы специальную, конфиденциальную или инсайдерскую информацию контрагентам Компании для обеспечения их преимущества перед конкурентами?<span class="black-90-text">*</span>
                </z-caption>
                <div class="row">
                    <div class="col-default-6 col-v-tablet-12">
                        <z-checkbox
                            name="question_y1[10]"
                            ref="question_y1[10]"
                            required
                            :checked="params.question_y1[10]"
                            @change="onBlockDataChangequestion"
                        >
                            Да
                        </z-checkbox>
                        <z-checkbox
                            name="question_n1[10]"
                            ref="question_n1[10]"
                            required
                            :checked="params.question_n1[10]"
                            @change="onBlockDataChangequestion"
                        >
                            Нет
                        </z-checkbox>
                    </div>
                    <div class="col-default-6 col-v-tablet-12">
                        <z-textarea
                            name="explanation_1[10]"
                            ref="explanation_1[10]"
                            placeholder="Пояснение к 1.10"
                            v-model="params.explanation_1[10]"
                            resize
                        />
                    </div>
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-default-12">
                <z-caption tag="p" class="u-bottom-margin--xs" size="s">
                    1.11 Знаете ли Вы о каком-либо сотруднике Компании, который является работником, консультантом или совладельцем компаний-контрагентов ООО «РУК», Управляемых Обществ или иных предприятий группы ПАО «Распадская»?<span class="black-90-text">*</span>
                </z-caption>
                <div class="row">
                    <div class="col-default-6 col-v-tablet-12">
                        <z-checkbox
                            name="question_y1[11]"
                            ref="question_y1[11]"
                            required
                            :checked="params.question_y1[11]"
                            @change="onBlockDataChangequestion"
                        >
                            Да
                        </z-checkbox>
                        <z-checkbox
                            name="question_n1[11]"
                            ref="question_n1[11]"
                            required
                            :checked="params.question_n1[11]"
                            @change="onBlockDataChangequestion"
                        >
                            Нет
                        </z-checkbox>
                    </div>
                    <div class="col-default-6 col-v-tablet-12">
                        <z-textarea
                            name="explanation_1[11]"
                            ref="explanation_1[11]"
                            placeholder="Пояснение к 1.11"
                            v-model="params.explanation_1[11]"
                            resize
                        />
                    </div>
                </div>
            </div>
        </div>
        <div class="sg-section">
            <z-caption tag="p" class="u-top-margin--m u-bottom-margin--xs" size="m">
                2. Отношения с конкурентами
            </z-caption>
        </div>
        <div class="row">
            <div class="col-default-12">
                <z-caption tag="p" class="u-bottom-margin--xs" size="s">
                    2.1 Имеете ли Вы или член Вашей семьи какую-либо собственность или финансовые интересы в компании-конкуренте ООО «РУК», Управляемых Обществ или иных предприятий группы ПАО «Распадская»?<span class="black-90-text">*</span>
                </z-caption>
                <div class="row">
                    <div class="col-default-6 col-v-tablet-12">
                        <z-checkbox
                            name="question_y2[1]"
                            ref="question_y2[1]"
                            required
                            :checked="params.question_y2[1]"
                            @change="onBlockDataChangequestion"
                        >
                            Да
                        </z-checkbox>
                        <z-checkbox
                            name="question_n2[1]"
                            ref="question_n2[1]"
                            required
                            :checked="params.question_n2[1]"
                            @change="onBlockDataChangequestion"
                        >
                            Нет
                        </z-checkbox>
                    </div>
                    <div class="col-default-6 col-v-tablet-12">
                        <z-textarea
                            name="explanation_2[1]"
                            ref="explanation_2[1]"
                            placeholder="Пояснение к 2.1"
                            v-model="params.explanation_2[1]"
                            resize
                        />
                    </div>
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-default-12">
                <z-caption tag="p" class="u-bottom-margin--xs" size="s">
                    2.2 Принимали ли Вы или член Вашей семьи какие-либо займы, подарки, деньги или приглашения в поездки или на мероприятия от конкурента Компании, ранее не согласованные комплаенс менеджером?<span class="black-90-text">*</span>
                </z-caption>
                <div class="row">
                    <div class="col-default-6 col-v-tablet-12">
                        <z-checkbox
                            name="question_y2[2]"
                            ref="question_y2[2]"
                            required
                            :checked="params.question_y2[2]"
                            @change="onBlockDataChangequestion"
                        >
                            Да
                        </z-checkbox>
                        <z-checkbox
                            name="question_n2[2]"
                            ref="question_n2[2]"
                            required
                            :checked="params.question_n2[2]"
                            @change="onBlockDataChangequestion"
                        >
                            Нет
                        </z-checkbox>
                    </div>
                    <div class="col-default-6 col-v-tablet-12">
                        <z-textarea
                            name="explanation_2[2]"
                            ref="explanation_2[2]"
                            placeholder="Пояснение к 2.2"
                            v-model="params.explanation_2[2]"
                            resize
                        />
                    </div>
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-default-12">
                <z-caption tag="p" class="u-bottom-margin--xs" size="s">
                    2.3 Есть ли у Вас или члена Вашей семьи отношения найма, консалтинга или контрактные отношения с каким-либо конкурентом Компании?<span class="black-90-text">*</span>
                </z-caption>
                <div class="row">
                    <div class="col-default-6 col-v-tablet-12">
                        <z-checkbox
                            name="question_y2[3]"
                            ref="question_y2[3]"
                            required
                            :checked="params.question_y2[3]"
                            @change="onBlockDataChangequestion"
                        >
                            Да
                        </z-checkbox>
                        <z-checkbox
                            name="question_n2[3]"
                            ref="question_n2[3]"
                            required
                            :checked="params.question_n2[3]"
                            @change="onBlockDataChangequestion"
                        >
                            Нет
                        </z-checkbox>
                    </div>
                    <div class="col-default-6 col-v-tablet-12">
                        <z-textarea
                            name="explanation_2[3]"
                            ref="explanation_2[3]"
                            placeholder="Пояснение к 2.3"
                            v-model="params.explanation_2[3]"
                            resize
                        />
                    </div>
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-default-12">
                <z-caption tag="p" class="u-bottom-margin--xs" size="s">
                    2.4 Передавали ли Вы служебную, конфиденциальную или инсайдерскую информацию конкурентам? (За исключением той, которую Компания уполномочила Вас предоставить для поддержания деловых отношений).<span class="black-90-text">*</span>
                </z-caption>
                <div class="row">
                    <div class="col-default-6 col-v-tablet-12">
                        <z-checkbox
                            name="question_y2[4]"
                            ref="question_y2[4]"
                            required
                            :checked="params.question_y2[4]"
                            @change="onBlockDataChangequestion"
                        >
                            Да
                        </z-checkbox>
                        <z-checkbox
                            name="question_n2[4]"
                            ref="question_n2[4]"
                            required
                            :checked="params.question_n2[4]"
                            @change="onBlockDataChangequestion"
                        >
                            Нет
                        </z-checkbox>
                    </div>
                    <div class="col-default-6 col-v-tablet-12">
                        <z-textarea
                            name="explanation_2[4]"
                            ref="explanation_2[4]"
                            placeholder="Пояснение к 2.4"
                            v-model="params.explanation_2[4]"
                            resize
                        />
                    </div>
                </div>
            </div>
        </div>
        <div class="sg-section">
            <z-caption tag="p" class="u-top-margin--m u-bottom-margin--xs" size="m">
                3. Отношения с ООО «РУК», Управляемыми Обществами или иными предприятиями группы ПАО «Распадская»
            </z-caption>
        </div>
        <div class="row">
            <div class="col-default-12">
                <z-caption tag="p" class="u-bottom-margin--xs" size="s">
                    3.1 Используете ли Вы ресурсы или оборудование Компании для извлечения личной материальной выгоды? Вопрос не касается технических средств (компьютер, телефон), которые Компания передала Вам в личное пользование для выполнения служебных обязанностей.<span class="black-90-text">*</span>
                </z-caption>
                <div class="row">
                    <div class="col-default-6 col-v-tablet-12">
                        <z-checkbox
                            name="question_y3[1]"
                            ref="question_y3[1]"
                            required
                            :checked="params.question_y3[1]"
                            @change="onBlockDataChangequestion"
                        >
                            Да
                        </z-checkbox>
                        <z-checkbox
                            name="question_n3[1]"
                            ref="question_n3[1]"
                            required
                            :checked="params.question_n3[1]"
                            @change="onBlockDataChangequestion"
                        >
                            Нет
                        </z-checkbox>
                    </div>
                    <div class="col-default-6 col-v-tablet-12">
                        <z-textarea
                            name="explanation_3[1]"
                            ref="explanation_3[1]"
                            placeholder="Пояснение к 3.1"
                            v-model="params.explanation_3[1]"
                            resize
                        />
                    </div>
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-default-12">
                <z-caption tag="p" class="u-bottom-margin--xs" size="s">
                    3.2 Являетесь ли Вы сотрудником другой компании, не связанной с ООО «РУК», Управляемыми Обществами или иных предприятий группы ПАО «Распадская», о чем Вы не уведомили своих руководителей (параллельная занятость)?<span class="black-90-text">*</span>
                </z-caption>
                <div class="row">
                    <div class="col-default-6 col-v-tablet-12">
                        <z-checkbox
                            name="question_y3[2]"
                            ref="question_y3[2]"
                            required
                            :checked="params.question_y3[2]"
                            @change="onBlockDataChangequestion"
                        >
                            Да
                        </z-checkbox>
                        <z-checkbox
                            name="question_n3[2]"
                            ref="question_n3[2]"
                            required
                            :checked="params.question_n3[2]"
                            @change="onBlockDataChangequestion"
                        >
                            Нет
                        </z-checkbox>
                    </div>
                    <div class="col-default-6 col-v-tablet-12">
                        <z-textarea
                            name="explanation_3[2]"
                            ref="explanation_3[2]"
                            placeholder="Пояснение к 3.2"
                            v-model="params.explanation_3[2]"
                            resize
                        />
                    </div>
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-default-12">
                <z-caption tag="p" class="u-bottom-margin--xs" size="s">
                    3.3 Есть ли у Вас родственники, работающие в ООО «РУК», Управляемых Обществах или иных предприятиях группы ПАО «Распадская»? Укажите, пожалуйста, ФИО.<span class="black-90-text">*</span>
                </z-caption>
                <div class="row">
                    <div class="col-default-6 col-v-tablet-12">
                        <z-checkbox
                            name="question_y3[3]"
                            ref="question_y3[3]"
                            required
                            :checked="params.question_y3[3]"
                            @change="onBlockDataChangequestion"
                        >
                            Да
                        </z-checkbox>
                        <z-checkbox
                            name="question_n3[3]"
                            ref="question_n3[3]"
                            required
                            :checked="params.question_n3[3]"
                            @change="onBlockDataChangequestion"
                        >
                            Нет
                        </z-checkbox>
                    </div>
                    <div class="col-default-6 col-v-tablet-12">
                        <z-textarea
                            name="explanation_3[3]"
                            ref="explanation_3[3]"
                            placeholder="Пояснение к 3.3"
                            v-model="params.explanation_3[3]"
                            resize
                        />
                    </div>
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-default-12">
                <z-caption tag="p" class="u-bottom-margin--xs" size="s">
                    3.4 Принимали ли Вы когда-либо в ООО «РУК», Управляемых Обществах или иных предприятиях группы ПАО «Распадская» решения, прямо или косвенно касающиеся Вашего родственника, который также является сотрудником ООО «РУК», Управляемых Обществ или иных предприятий группы ПАО «Распадская»?<span class="black-90-text">*</span>
                </z-caption>
                <div class="row">
                    <div class="col-default-6 col-v-tablet-12">
                        <z-checkbox
                            name="question_y3[4]"
                            ref="question_y3[4]"
                            required
                            :checked="params.question_y3[4]"
                            @change="onBlockDataChangequestion"
                        >
                            Да
                        </z-checkbox>
                        <z-checkbox
                            name="question_n3[4]"
                            ref="question_n3[4]"
                            required
                            :checked="params.question_n3[4]"
                            @change="onBlockDataChangequestion"
                        >
                            Нет
                        </z-checkbox>
                    </div>
                    <div class="col-default-6 col-v-tablet-12">
                        <z-textarea
                            name="explanation_3[4]"
                            ref="explanation_3[4]"
                            placeholder="Пояснение к 3.4"
                            v-model="params.explanation_3[4]"
                            resize
                        />
                    </div>
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-default-12">
                <z-caption tag="p" class="u-bottom-margin--xs" size="s">
                    3.5 Делали ли Вы копии конфиденциальных материалов, принадлежащих Компании, для передачи третьим лицам без разрешения уполномоченных лиц? Вопрос касается также и отправки конфиденциальной или служебной информации Компании на адрес личной электронной почты для пересылки третьим лицам.<span class="black-90-text">*</span>
                </z-caption>
                <div class="row">
                    <div class="col-default-6 col-v-tablet-12">
                        <z-checkbox
                            name="question_y3[5]"
                            ref="question_y3[5]"
                            required
                            :checked="params.question_y3[5]"
                            @change="onBlockDataChangequestion"
                        >
                            Да
                        </z-checkbox>
                        <z-checkbox
                            name="question_n3[5]"
                            ref="question_n3[5]"
                            required
                            :checked="params.question_n3[5]"
                            @change="onBlockDataChangequestion"
                        >
                            Нет
                        </z-checkbox>
                    </div>
                    <div class="col-default-6 col-v-tablet-12">
                        <z-textarea
                            name="explanation_3[5]"
                            ref="explanation_3[5]"
                            placeholder="Пояснение к 3.5"
                            v-model="params.explanation_3[5]"
                            resize
                        />
                    </div>
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-default-12">
                <z-checkbox
                    class="u-top-margin--m"
                    name="agreement2"
                    ref="agreement2"
                    required
                    :checked="params.agreement2"
                    @change="onBlockDataChange"
                >
                    Заполняя этот Опросник по раскрытию информации, я подтверждаю, что прочитал(а), понял(а) и раскрыл(а) все возможные конфликты интересов. Я подтверждаю, что в соответствии с Политикой сообщу о любом вновь возникающем конфликте интересов комплаенс менеджеру и своему руководителю.<span class="black-90-text">*</span>
                </z-checkbox>
            </div>
        </div>
        <div class="conflict-form__buttons">
            <z-button @click="submit">Отправить</z-button>
            <z-button @click="reset" kind="secondary">Сбросить всё</z-button>
        </div>
        <z-modal
            id="success-modal"
        >
            <div class="seekers-form-success">
                <z-icon
                    name="worker"
                    width="96"
                    height="96"
                    class="u-bottom-margin--m"
                />
                <p>
                    Спасибо! Ваши ответы приняты.
                </p>
            </div>
        </z-modal>
    </div>
</template>
<script>
const axios = require('axios').default

export default {
    name: 'conflict-form',
    data () {
        return {
            isLoading: false,
            params: {
                'FIRST_NAME': '',
                'LAST_NAME': '',
                'MIDDLE_NAME': '',
                agreement: false,
                agreement2: false,
                DIVIZ: {},
                question_y1: [],
                question_n1: [],
                explanation_1: [],
                question_y2: [],
                question_n2: [],
                explanation_2: [],
                question_y3: [],
                question_n3: [],
                explanation_3: []
            },
            type: 'form'
        }
    },
    methods: {
        onBlockDataChangequestion (data) {
            this.params[data.name] = data.value
            this.$refs[data.name].check = data.value

            if (data.value) {
                var index = []
                var nameq = ''
                if (data['name'].includes('question_y')) {
                    index = data['name'].split('question_y')
                    nameq = 'question_n' + index[1]

                    this.$refs[nameq].isValid = true
                    this.$refs[nameq].error = false
                } else {
                    index = data['name'].split('question_n')
                    nameq = 'question_y' + index[1]

                    this.$refs[data['name']].isValid = true
                    this.$refs[data['name']].error = false
                }

                this.$refs[nameq].check = false
                this.params[nameq] = false
            }
        },
        onBlockDataChange (data) {
            this.params[data.name] = data.value
        },
        onSelDataChange (data) {
            this.params['DIVIZ'] = {text: this.$refs.DIVIZ.selected.text, value: data}
        },
        submit () {
            const isValid = this.isValid()

            if (isValid && !this.isLoading) {
                this.isLoading = true
                this.send()
            }
        },
        send () {
            let formData = this.buildFormData(this.params)

            axios.post(`/${this.$root.lang}/api/conflic/save-form/`, formData)
                .then(res => {
                    if (res.status === 'error') {
                        console.log(res.message)
                        // showNotyfications(res.message, { type: 'error' })
                    } else {
                        // console.log(res)
                        this.reset()
                        this.openSuccessModal()
                    }
                })
                .finally(() => {
                    this.isLoading = false
                })
        },
        openSuccessModal () {
            this.$root.$bus.$emit('open-modal', {id: 'success-modal', index: 1})
        },
        buildFormData (data) {
            let formData = new FormData()

            for (let key in data) {
                if (data.hasOwnProperty(key)) {
                    if (key === 'DIVIZ') {
                        formData.append(key, JSON.stringify(data[key]))
                    } else {
                        if (Array.isArray(data[key])) {
                            for (let value in data[key]) {
                                formData.append(key + '[' + value + ']', data[key][value])
                            }
                        } else {
                            formData.append(key, data[key])
                        }
                    }
                }
            }

            return formData
        },
        reset () {
            for (let key in this.params) {
                if (key.includes('explanation_')) {
                    for (let key1 in this.params[key]) {
                        this.$refs[key + '[' + key1 + ']'].textareaValue = ''
                    }
                } else if (key.includes('question_')) {
                    if (this.$refs[key]) this.$refs[key].check = false
                }
            };

            this.params = {
                'FIRST_NAME': '',
                'LAST_NAME': '',
                'MIDDLE_NAME': '',
                agreement: false,
                agreement2: false,
                DIVIZ: {},
                question_y1: [],
                question_n1: [],
                explanation_1: [],
                question_y2: [],
                question_n2: [],
                explanation_2: [],
                question_y3: [],
                question_n3: [],
                explanation_3: []
            }

            if (this.$refs.agreement) this.$refs.agreement.check = false
            if (this.$refs.agreement2) this.$refs.agreement2.check = false
            if (this.$refs.DIVIZ) {
                this.$refs.DIVIZ.removeSelected()
                this.$refs.DIVIZ.isValid = true
                this.$refs.DIVIZ.error = false
            }
        },
        isValid () {
            let isValid = true

            for (let key in this.$refs) {
                try {
                    if (key.includes('question_y')) {
                        let arrQ = key.split('question_y')
                        let nameQ = 'question_n' + arrQ[1]
                        if (!this.$refs[key].check && !this.$refs[nameQ].check) this.$refs[nameQ].validate()
                    } else if (!key.includes('question_n')) {
                        this.$refs[key].validate()
                    }

                    if (this.$refs[key].error) {
                        isValid = false
                    }
                } catch (e) {
                    console.error(`error on validate ${key}`)
                }
            }

            return isValid
        }
    }
}
</script>

<style lang="scss">
.conflict-form {
    padding-right: $token-spacers-s; // для компенсации кнопок удалить блок

    @include breakpoint (mobile) {
        padding-right: 0;
    }

    .row {
        margin-top: -$token-spacers-xs;

        & + * {
            margin-top: $token-spacers-xs;
        }

        & > [class*="col-"] {
            margin-top: $token-spacers-xs;
        }
    }

    .z-button--kind-text {
        .z-button__icon {
            path {
                fill: $token-colors-white;
            }
        }
    }

    &__buttons {
        @include margin-level(top, M);
        display: flex;

        @include breakpoint (mobile) {
            display: block;
        }

        .z-button {
            @include margin-level(right, S);

            &:last-child {
                margin-right: 0;
            }

            @include breakpoint (mobile) {
                margin-right: 0;
                @include margin-level(top, S);
            }
        }
    }

    &__add-button {
        display: flex;
        justify-content: flex-end;
        margin-top: $token-spacers-xs;
    }
}

</style>
